import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { BsFillMoonFill, BsFillSunFill } from 'react-icons/bs';
import { ThemeContext } from '../../contexts/ThemeContext';
import './ChangeTheme.css';

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: '1.5rem',
    color: ({ theme }) => theme.buttonColor,
    transition: 'transform 0.2s ease-in-out, color 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.08)',
      color: ({ theme }) => theme.tertiary,
    },
  },
}));

const ChangeTheme = () => {
  const { theme, changeTheme, isDark } = useContext(ThemeContext);
  const classes = useStyles({ theme });

  return (
    <div className='changeTheme'>
      <button 
        onClick={changeTheme} 
        aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      >
        {isDark ? (
          <BsFillSunFill className={classes.icon} />
        ) : (
          <BsFillMoonFill className={classes.icon} />
        )}
      </button>
    </div>
  );
};

export default ChangeTheme;